import { BigNumber } from 'ethers'
import { commify, formatUnits, parseUnits } from 'ethers/lib/utils'
import { Currency } from '~/domain/Currency'

export const cronosTestnetLegend: Currency = {
  chainId: 338,
  address: '0xF35908524C9273F9C24380D506504388B8789564',
  symbol: 'LEGEND',
  decimals: 18,
}

export const amoyLegend: Currency = {
  chainId: 80002,
  address: '0x8b377fdAcb6D5Bd4d13707fB7b9a2D523A4Afdf4',
  symbol: 'LEGEND',
  decimals: 18,
}

export const polygonLegend: Currency = {
  chainId: 137,
  address: '0xcC60c7c0Cf827355BB9FdC6d1F26f2fEE8aBc26d',
  symbol: 'LEGEND',
  decimals: 18,
}

export const polygonUsdt: Currency = {
  chainId: 137,
  address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
  symbol: 'USDT',
  decimals: 6,
}

export const formatLegend = (amount: BigNumber, fractionDigits?: number): string => {
  let amountString = formatUnits(amount, 18)

  if (fractionDigits !== undefined) {
    const value = parseFloat(amountString)
    const roundedValue = Math.round((value + Number.EPSILON) * 1000) / 1000

    amountString = roundedValue.toFixed(fractionDigits)
  }

  const result = commify(amountString)

  if (result.endsWith('.0')) {
    return result.substring(0, result.length - 2)
  }

  return result
}

export const parseLegend = (amount: string): BigNumber => {
  return parseUnits(amount, 18)
}
